export const APPEND_DATA = "APPEND_DATA"

 
export const RESET_DATA="RESET_DATA"